import restApi from "./restApi";

export default {
  users: restApi("users"),
  cities: restApi("cities"),
  rooms: restApi("rooms"),
  offices: restApi("offices")
};
